import { gql } from '@apollo/client';

const BLOCK_PHONE_NUMBER = gql`
  mutation BlockPhoneNumber(
    $blockEnd: String
    $customerIds: [String!]
    $phoneNumber: String!
    $reasonCode: BlockNumberReasonCode!
    $reasonDescription: String
  ) {
    blockPhoneNumber(
      blockEnd: $blockEnd
      customerIds: $customerIds
      phoneNumber: $phoneNumber
      reasonCode: $reasonCode
      reasonDescription: $reasonDescription
    ) {
      id
      alreadyBlocked
      blockEnd
      blockStart
      insertBy
      isBlocked
      lastModifiedBy
      lastModifiedDate
      phoneNumber
      reasonCode
      reasonDescription
    }
  }
`;

const UPDATE_BLOCKED_PHONE_NUMBER = gql`
  mutation UpdateBlockedPhoneNumber(
    $id: String!
    $blockEnd: String
    $reasonCode: BlockNumberReasonCode
    $reasonDescription: String
    $unblock: Boolean
  ) {
    updateBlockedPhoneNumber(
      id: $id
      blockEnd: $blockEnd
      reasonCode: $reasonCode
      reasonDescription: $reasonDescription
      unblock: $unblock
    ) {
      id
      alreadyBlocked
      blockEnd
      blockStart
      insertBy
      isBlocked
      lastModifiedBy
      lastModifiedDate
      phoneNumber
      reasonCode
      reasonDescription
    }
  }
`;

export { BLOCK_PHONE_NUMBER, UPDATE_BLOCKED_PHONE_NUMBER };
